import { Button } from "antd";
import CheckboxInput from "components/Form/CheckboxInput";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import LabeledTextArea from "components/Form/LabeledTextArea";
import PhoneIcon from "components/Icons/PhoneIcon";
import useCreateAppVersion from "hooks/useCreateAppVersion";

export default function CreateAppVersion() {
  const { control, handleSubmit, loading, onSubmit } = useCreateAppVersion();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">
            Add New App Version
          </h1>
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <PhoneIcon />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            Version Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full flex flex-wrap"
          >
            <div className="w-full px-4 pt-5 md:w-1/2">
              <LabeledInput
                label="Version"
                type="text"
                control={control}
                name="version"
                placeholder="Version"
              />
            </div>
            <div className="w-full px-4 pt-5 md:w-1/2">
              <LabeledSelectInput
                label="Platform"
                control={control}
                name="platform"
                placeholder="Select Platform"
                options={[
                  { value: "android", label: "Android" },
                  { value: "ios", label: "iOS" },
                ]}
              />
            </div>
            <div className="w-full px-4 pt-5 md:w-1/2">
              <LabeledTextArea
                label="Description"
                control={control}
                rows={4}
                name="description"
                placeholder={`- Localization support for multiple languages
- Bug fixes and performance improvements`}
              />
            </div>
            <div className="w-full px-4 pt-5 md:w-1/2">
              <CheckboxInput
                title="Driver Force Update"
                control={control}
                name="driver_force_update"
              />
            </div>
            <div className="w-full px-4 pt-5 md:w-1/2">
              <CheckboxInput
                title="Passenger Force Update"
                control={control}
                name="passenger_force_update"
              />
            </div>
            <div className="w-full flex mt-8 justify-end">
              <Button
                loading={loading}
                htmlType="submit"
                type="primary"
                className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
              >
                Add Version
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
